/**
 * The record page's address, apart from the page, so the two routes that
 * validate it do not load the page before it is opened.
 */
import { z } from 'zod';

/** `?q=`: the words a record's search holds. Absent is the whole list. */
export const recordSearchSchema = z.object({
  q: z.string().optional().catch(undefined),
});
